export default "__VITE_ASSET__c0af8deb__"